<template>
  <el-menu
    :default-active="$route.path"
    class="el-menu-vertical-demo aside"
    background-color="#2467B1"
    text-color="#fff" 
    active-text-color="#ffd04b"
    router
    @open="handleOpen"
    @close="handleClose"
  >
    <el-submenu :index="item.name"  v-for="(item,index) in menuList" :key="index">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span>{{item.name}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item 
          v-for="(subItem,subIndex) in item.children"
          :key="subIndex"
          :index="'/'+subItem.url" 
        >
          {{subItem.name}}
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  name: "MainMenu",
  props: {
    menuList:Array
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    // changeRoute(route){
    //   this.$router.push(route)
    // }
  },
  created() {
    console.log(this.$route.path);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.aside {
  height: 100%;
  /* overflow-y: hidden; */
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>
